// useErrorHandler.ts
import { AxiosError } from 'axios';
import useCustomToast from '@/components/common/Toast';

interface ErrorResponse {
  message?: string;
  non_field_errors?: string[];
  errors?: {
    [key: string]: string[];
  };
  detail?: string;
  code?: string[];
}

const useErrorHandler = () => {
  const { showToast } = useCustomToast();

  const handleError = (error: AxiosError) => {
    let message = 'An unexpected error occurred.';

    if (error.response) {
      const { data } = error.response;

      const errorData = data as ErrorResponse;

      if (Array.isArray(errorData.non_field_errors) && errorData.non_field_errors.length > 0) {
        message = errorData.non_field_errors.join(', ');
      } else if (errorData.message) {
        message = errorData.message;
      } else if (errorData.detail) {
        message = errorData.detail;
      } else if (errorData.code) {
        message = errorData?.code?.[0];
      } else if (errorData.errors) {
        const fieldErrors = Object.values(errorData.errors).flat();
        if (fieldErrors.length > 0) {
          message = fieldErrors.join(', ');
        }
      }
    } else if (error.message) {
      message = error.message;
    }

    showToast('error', message);
  };

  return { handleError };
};

export default useErrorHandler;
